var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiomarkerYellowWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7159 0.0527344H8.28413C6.65235 0.0527344 5.14367 0.918499 4.32779 2.32537L0.611916 8.72747C-0.203972 10.1334 -0.203972 11.8659 0.611916 13.2718L4.32779 19.6748C5.14367 21.0808 6.65235 21.9475 8.28413 21.9475H15.7159C17.3476 21.9475 18.8563 21.0817 19.6722 19.6748L23.3881 13.2718C24.204 11.8659 24.204 10.1334 23.3881 8.72747L19.6732 2.32537C18.8563 0.918499 17.3486 0.0527344 15.7159 0.0527344Z",
    fill: "#F1B44C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiomarkerYellowWarning);
export default __webpack_public_path__ + "static/media/biomarker-yellow-warning.4cf5af3a24a343aa61bbecfad54b1319.svg";
export { ForwardRef as ReactComponent };